import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import useShowPassword from '../../hooks/useShowPassword';
import { viewPrivacyPolicy } from '../../services/amplitude';
import { TextInput } from '../TextInput';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const FormLogin = ({ errors, login, formOnChange, onLogin, }) => {
  const { onShowPassword, showPassword } = useShowPassword({
    typePassword: 'password',
    typePasswordConfirm: 'password_confirm',
  });

  const [hoverSubmit, setHoverSubmit] = useState(false)

  const isDesktop = useMediaQuery('(min-wdith: 993px)')

  return (
    <>
      <Box component='form' onSubmit={(e) => {
        e.preventDefault()
        onLogin()

      }}>
        <TextInput
          label="Email"
          placeholder="Masukan Alamat Email Anda"
          error={errors.email}
          value={login.email}
          onChange={formOnChange}
          name="email"
          type="email"
        />
        <TextInput
          label="Kata Sandi"
          placeholder="Masukan Kata Sandi Anda"
          error={errors.password}
          value={login.password}
          onChange={formOnChange}
          name="password"
          type="password"
          show={showPassword.password}
          onShow={onShowPassword}
        />
        <div className="form-check mt-3">
          <input className="form-check-input" type="checkbox" />
          <label className="form-check-label">Ingat Saya</label>
          <a href="/lupa-kata-sandi" className="float-right ml-1" style={{ color: 'green' }}>
            Lupa Kata Sandi
          </a>
        </div>
        <p className="terms-condition">
          <Box
            component="span"
            sx={{
              marginRight: '4px',
            }}
          >
            Anda telah mengetahui dan menyetujui
          </Box>
          <a href="/syarat-ketentuan" onClick={() => viewPrivacyPolicy()}>
            Syarat & Ketentuan
          </a>{' '}
          dari IBID MAP
        </p>

        <Button type='submit' variant={hoverSubmit ? 'outlined' : 'contained'}
          color='primaryMAP'
          sx={{
            marginTop: '8px'
          }}
          fullWidth
          onMouseLeave={() => setHoverSubmit(false)} onMouseEnter={() => setHoverSubmit(true)}>Masuk</Button>
      </Box>

      <Box sx={{
        marginTop: isDesktop ? '24px' : '16px',
        justifyContent: 'center',
        gap: '4px',
        display: 'flex',
      }}>
        Belum punya akun ?
        <Link to='/register' state={{
          pageChannel: 'Login Page',
        }}>
          <Typography component='span' color='primaryMAP'>
            Daftar di sini
          </Typography>
        </Link>
      </Box>
    </>
  );
};

export default FormLogin;
